<template>
  <Row :gutter="24">
    <Col
      class="showItem"
      :span="type == 'department' ? 12 : 6"
      v-for="(item, index) in list"
      :key="item.id + index"
    >
      <span v-if="type == 'department'">
        {{ item.topTitle ? `${item.title}-${item.topTitle}` : item.title }}
      </span>
      <span v-else>{{ item.title }}</span>
      <i class="delItem anticon anticon-close close" @click="delItem(item)"></i>
    </Col>
  </Row>
</template>
<script>
export default {
  name: 'selectShowList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {};
  },
  methods: {
    delItem(deleteItem) {
      this.$emit('on-delete-item', deleteItem);
    }
  }
};
</script>
<style lang="less" scoped>
.showItem {
  margin-top: 10px;
}
.delItem {
  color: #ccc;
  margin-left: 10px;
  cursor: pointer;
}
</style>
